module.exports = __webpack_public_path__ + "img/slider-right.7d9cf088.svg";